/**
 * src/lib/spotlightHoSo.js: đọc và ghi hồ sơ một trang Startup Spotlight.
 *
 * Collection spotlight_ho_so CHỈ quản trị đọc và ghi (xem firestore.rules).
 * Ở đây có quy mô vòng, định giá, số đã cam kết: tuyệt đối không mở đọc công khai.
 */
import { layDb } from './firebase.js';
import { chuanHoaHoSo } from './spotlightModel.js';

async function fs() {
  const db = await layDb();
  if (!db) throw new Error('Website chưa kết nối được máy chủ.');
  return { db, f: await import('firebase/firestore/lite') };
}

const ngay = (t) => (t?.toDate ? t.toDate() : null);

export async function docTatCaHoSo() {
  const { db, f } = await fs();
  const snap = await f.getDocs(f.collection(db, 'spotlight_ho_so'));
  return snap.docs
    .map((d) => ({ id: d.id, ...chuanHoaHoSo(d.data()), capNhat: ngay(d.data().capNhat) }))
    .sort((a, b) => (b.capNhat?.getTime() || 0) - (a.capNhat?.getTime() || 0));
}

/** Lưu hồ sơ. Chưa có id thì tạo mới. Trả về id. */
export async function luuHoSo(id, hoSo) {
  const { db, f } = await fs();
  const data = { ...chuanHoaHoSo(hoSo), capNhat: f.serverTimestamp() };
  if (id) {
    await f.setDoc(f.doc(db, 'spotlight_ho_so', id), data);
    return id;
  }
  const ref = await f.addDoc(f.collection(db, 'spotlight_ho_so'), data);
  return ref.id;
}

export async function xoaHoSo(id) {
  const { db, f } = await fs();
  await f.deleteDoc(f.doc(db, 'spotlight_ho_so', id));
}
